import React from 'react'

interface IconProps {
  className?: string
}

const GUIDEcx = ({ className }: IconProps) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="48" height="48" rx="10" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1925 15.8749C14.3014 17.7097 13.027 20.4757 13.027 24.2047C13.027 31.4462 18.2764 34.973 23.1944 34.973H32.0558C32.6522 34.973 33.4114 34.8136 33.9797 34.3964C34.469 34.0372 34.973 33.38 34.973 31.9832V25.7182H24.4028C23.5669 25.7182 22.8893 25.0406 22.8893 24.2047C22.8893 23.3688 23.5669 22.6912 24.4028 22.6912H35.7297C36.9819 22.6912 38 23.7053 38 24.9608V31.9832C38 34.2708 37.0942 35.8653 35.7709 36.8366C34.5267 37.75 33.0705 38 32.0558 38H23.1944C16.8344 38 10 33.3389 10 24.2047C10 19.7458 11.5452 16.1662 14.0847 13.7024C16.6115 11.2509 20.0238 10 23.5972 10H36.4865C37.3224 10 38 10.6776 38 11.5135C38 12.3494 37.3224 13.027 36.4865 13.027H23.5972C20.7259 13.027 18.0964 14.0278 16.1925 15.8749ZM18.6965 18.4453C20.1611 17.2017 22.0117 16.5503 23.5972 16.5503H36.4865C37.3224 16.5503 38 17.2279 38 18.0638C38 18.8997 37.3224 19.5773 36.4865 19.5773H23.5972C22.766 19.5773 21.6018 19.9494 20.6558 20.7527C19.7499 21.5219 19.0811 22.651 19.0811 24.2047C19.0811 26.0902 19.6983 27.1766 20.4425 27.8157C21.2273 28.4897 22.3484 28.8321 23.5972 28.8321H30.4446C31.2805 28.8321 31.9582 29.5097 31.9582 30.3456C31.9582 31.1815 31.2805 31.8591 30.4446 31.8591H23.5972C21.8434 31.8591 19.9497 31.3827 18.4703 30.1121C16.9503 28.8066 16.0541 26.8225 16.0541 24.2047C16.0541 21.6645 17.1917 19.7231 18.6965 18.4453Z"
      fill="white"
    />
  </svg>
)

export default GUIDEcx
